import { Tooltip, IconButton } from '@mui/material'
import { ReactComponent as TooltipIcon } from 'assets/icons/tooltip.svg'

export const DeckMappToolTip = ({ title }) => {
  return (
    <Tooltip placement="bottom" title={title}>
      <IconButton
        onClick={(e) => {
          e.currentTarget.blur()
        }}>
        <TooltipIcon />
      </IconButton>
    </Tooltip>
  )
}
